module.exports = __webpack_public_path__ + "static/media/industry-alt.4a80db2a.svg";